import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-writer',
  templateUrl: './writer.component.html',
  styleUrls: ['./writer.component.scss']
})
export class WriterComponent implements OnInit {
  authorList: any;
  yearsList: any;
  na = 4; 
  url = this.api.url;
  page:any = 1;
  pageSize: any = 20;
  total: any;
  navId: any;
  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.GetMTaxonomy();
  }
  GetMTaxonomy() {
    this.api.GetMTaxonomy('ZuoZheNianFen').subscribe(
      data => {
      this.yearsList = data;
      this.GetAuthorList(this.yearsList[4].taxonomyId, 1, 20);
      }
    )
  }
  GetAuthorList(id:any, page: any, pageSize: any) {
    this.navId = id;
    this.api.GetAuthorList(id , page, pageSize).subscribe (
      data => {
        this.total = data.total;
        this.authorList = data.authorList;
      }
    )
  }
  nActive(i:any, id: any) {
    this.na = i
    this.GetAuthorList(id, 1, 20);
  }

}
